import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useMarket } from "@/lib/market";
import { useAuth } from "@/lib/auth";
import { inr, label } from "@/lib/fmt";
import { PageHead } from "@/components/Layouts";
import ListingCard from "@/components/ListingCard";
import { Section, Loading, Empty } from "@/components/Bits";

export default function Saved() {
  const { savedIds, toggleSave, compare, toggleCompare, catName } = useMarket();
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  const [searches, setSearches] = useState([]);
  useEffect(() => { api.get("/saved").then((r) => setItems(r.data)); api.get("/saved-searches").then((r) => setSearches(r.data)); }, [savedIds]);
  const del = async (id) => { await api.delete(`/saved-searches/${id}`); setSearches(searches.filter((s) => s.id !== id)); };
  const toggleEmail = async (s) => {
    try {
      await api.delete(`/saved-searches/${s.id}`);
      const { data } = await api.post("/saved-searches", { ...s, alerts_email: !s.alerts_email });
      setSearches(searches.map((x) => (x.id === s.id ? data : x)));
      if (!s.alerts_email && !user.email_alerts) toast.warning("Turn on email alerts in Account to receive emails.");
    } catch (e) { toast.error(errMsg(e)); }
  };
  const qs = (q) => new URLSearchParams(Object.entries(q).filter(([k]) => !k.startsWith("price")).map(([k, v]) => [k, v])).toString();
  return (
    <div>
      <PageHead eyebrow="Buyer" title="Saved businesses & searches" right={compare.length > 0 && <Link to="/compare" className="btn-accent" data-testid="go-compare-btn">Compare {compare.length}</Link>} />
      {items === null ? <Loading /> : items.length === 0 ? <Empty title="No saved businesses" body="Tap Save on any listing to keep it here." action={<Link to="/browse" className="btn-primary">Explore</Link>} testid="saved-empty" /> : (
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-6" data-testid="saved-list">{items.map((l) => <ListingCard key={l.id} l={l} saved onSave={toggleSave} inCompare={compare.includes(l.id)} onCompare={toggleCompare} catName={catName(l.data.category)} />)}</div>
      )}
      <div className="mt-10"><Section title="Saved searches" testid="saved-searches">
        {searches.length === 0 ? <p className="text-sm text-stone-500">Save a search from the browse page to get in-app alerts when new businesses match.</p> : searches.map((s) => (
          <div key={s.id} className="flex flex-col sm:flex-row sm:items-center gap-2 py-3 border-b border-[#EFE6D8] last:border-0">
            <Link to={`/browse?${qs(s.query)}`} className="flex-1"><p className="font-semibold text-sm">{s.name}</p><p className="text-xs text-stone-500">{Object.entries(s.query).map(([k, v]) => `${label(k)}: ${k.startsWith("price") ? inr(v) : v}`).join(" · ") || "All listings"}</p></Link>
            <span className="chip bg-[#DCEBE2]">In-app alerts on</span>
            <button className="btn-ghost btn-sm" onClick={() => toggleEmail(s)} data-testid={`email-alert-toggle-${s.id}`}>Email alerts: {s.alerts_email ? "on" : "off"}</button>
            <button className="btn-ghost btn-sm" onClick={() => del(s.id)} aria-label="Delete saved search" data-testid={`delete-search-${s.id}`}><Trash2 size={14} /></button>
          </div>
        ))}
      </Section></div>
    </div>
  );
}
